module.exports = __webpack_public_path__ + "static/media/chevron-double-up.2e7dd1d5.svg";